export const generalAppInfo = {
  APP_NAME: "Siju Checkout",
  ORG_NAME: "TruQ Dynamic Services",
  APP_VERSION: "v1",
  DODGE_BASE_URL: 'https://dodge-apis-c2btvqbhlq-uc.a.run.app',
  // DODGE_BASE_URL: 'https://dodge.truq.it',
  DODGE_STAGING_BASE_URL: 'https://dodge-apis-staging-c2btvqbhlq-uc.a.run.app',
  SIJU_PK: "pk_live_b7911570ac2162e04582a60a40322bbf",
  SIJU_STAGING_PK: "pk_sandbox_ebe242fafd51aad297ccfaebaa965fa1",
};

export const Loading = {
  SUCCESS: "SUCCESS",
  OK: 200
};

export const highPriorityKeys = [
  "loaders",
  "packaging_boxes",
  "cellotape",
  "shrink_wrap",
  "bubble_wrap",
  "packaging_services"
];
